/*
    Redirect the page to the path specified in OnSuccessUrl upon successful doSubmit
 */
define('shared/initializer/form/adapters/mixins/Redirectable',[
    '$',
    'shared/lib/RSVP',
    'shared/initializer/form/constants'
], function (
    $,
    RSVP,
    constants
) {
    'use strict';

    function Ctor() { }

    function backgroundRedirect() {
        var me = this;

        if (
            me.configs && 
            me.configs.redirectable && 
            me.configs.redirectable.backgroundRedirectWhenSkipped && 
            me.configs.redirectable.url
        ) {

            if (!me.configs.redirectable.$iframe) {
                me.configs.redirectable.$iframe = $(document.createElement('iframe'));
            }

            var $iframe = me.configs.redirectable.$iframe;

            $iframe
            .css({
                'visibility': 'hidden',
                'position': 'absolute',
                'top': '-9000px',
                'width': '20px',
                'height': '20px'
            })
            .attr('src', me.configs.redirectable.url)
            .appendTo(document.body);
        }
    }
    
    Ctor.prototype.doAfterSubmit = function(data){
        var me = this;
        var $form = me.$form;

        if (me.options.redirectable && me.options.redirectable.enable === false) {
            return RSVP.resolve(data);
        }

        return new RSVP.Promise(function(resolve) {
            var $el = $form.find('input[name=' + constants.FIELD.OnSuccessUrl + ']');

            if (me.nextPageUrl) {
                window.location.href = me.nextPageUrl;
                resolve();
                return;
            }
            else if ($el.length > 0) {
                var nextPage = $el.val();
                if(nextPage){
                    window.location.href = nextPage;
                    resolve();
                    return;
                }
            }

            backgroundRedirect.call(me);
            resolve(data);
        });
    };

    return Ctor;
});
